<template>
  <div class="community">
        <nav-bar title="热门社区"></nav-bar>
    <returnPre></returnPre>
		<div class="" style="height:40px;color:#888888;margin-top:50px;text-align:center;font-size:14px;line-height:40px;color:#333333;font-weight:bold">金牌合作伙伴</div>
        <ul
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="150">
          <li  v-for="item in communityList">
                <div class="top" @click="detail(item.id,item.uid)">
                  <img :src="item.organizerLogo" alt="">
                </div>
          </li>
        </ul>
  </div>
</template>

<script>
export default {
    data() {
        return {
            communityList: {},
            currentPage: 1,
            toggle: true,
            nomore: false,
            first: true
        }
    },
    computed: {
        getCommunity:function(){
            return this.$store.state.community
        }

    },
    created() {
        this.nomore = false
        let that = this
        this.$axios.get('api/org/getOrgs?'+"page="+ that.currentPage)
        .then(res=> {
          console.log('热门社区数据', res)
            that.communityList = res.data.data.orgList
            that.currentPage++
        })
    },
  mounted() {
    this.getShareInfo()
  },
    methods: {
        detail(ID,uid) {
            /*
            this.$store.state.community = item
            this.$router.push(
                {name: 'communitydetail',
                query: {
                    id: ID,
                    message: JSON.stringify(item)
                }}
            )
            */
          var curUrl = (window.location.href).toString();
          if (curUrl.indexOf('itdks.com') > -1) { // 线上环境
            window.location.href = 'https://www.itdks.com/MobileMyInfo/CommunityDetail.html?id=' + ID +'&toId=' + uid
          } else {  // 本地环境
            window.location.href = 'https://www.apm.com/MobileMyInfo/CommunityDetail.html?id=' + ID +'&toId=' + uid
          }
        },
      loadMore: function() {
        if (this.nomore) {
          console.log('this.nomore')
          return
        }
        if (!this.toggle){
          console.log('this.toggle')
          return
        }
        console.log('走你')
        this.toggle = false
        let that = this;
        this.loading = true;
        setTimeout(() => {
          console.log('that.currentPage', that.currentPage)
          this.$axios.get('api/org/getOrgs?'+ "page=" + that.currentPage).then(res => {
            that.toggle = true
            if (res.data.data.orgList.length == 0) {
              that.nomore = true
            } else {
              that.communityList = [...that.communityList, ...res.data.data.orgList]

              that.currentPage++
            }
            this.loading = false
          })
        }, 1000)
      }
    }
}
</script>

<style lang="less" scoped>
    * {
        margin: 0;
        padding: 0
    }
    body {
        background: #f4f4f4;
    }
    .community ul {
        padding: 18px 0px 0px 49px;
        box-sizing: border-box;
        margin-bottom: 92px;
        margin-top: 2px;
        li {
        margin-bottom: 18px;
        display: inline-block;
        margin-right: 20px;
        box-shadow: 2px 2px 2px #666;
            .top {
            width: 315px;
            height: 175px;
            overflow: hidden;
            background-color: #fff;
            padding: 40px 50px;
            box-sizing: border-box;
            img {
                // width: 200px;
                height: 100px;
            }
            }
            .bottom {
                width: 275px;
                margin-left: 20px;
                height: 69px;
                text-align: center;
                line-height: 69px;
                font-size: 26px;
                color: #000;
                font-weight: 700;
                border-top: 1px solid #cccccc;/*no*/
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Community/Community.vue